import React from "react";
import PropTypes from "prop-types";

const Row = (props) => {
	return (<div className="u-clear">
		{props.children}
	</div>);
};

Row.propTypes = {
	children: PropTypes.node
};

export default Row;
